import ReactApexChart from 'react-apexcharts';

export default function PieChartItem({data}){
  const series= data.map(obj=>
    obj.value);
  const options = {
    chart: {
    type: 'donut',
  },
  legend: {
    show: false
  },
  dataLabels: {
    enabled: false
  }
  };

  return(
    <div id="chart">
      <ReactApexChart options={options} series={series} type="donut" />
    </div>
  );
}